import { render, staticRenderFns } from "./PlanCard.vue?vue&type=template&id=4a66bd09&scoped=true"
import script from "./PlanCard.vue?vue&type=script&lang=js"
export * from "./PlanCard.vue?vue&type=script&lang=js"
import style0 from "./PlanCard.vue?vue&type=style&index=0&id=4a66bd09&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a66bd09",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a66bd09')) {
      api.createRecord('4a66bd09', component.options)
    } else {
      api.reload('4a66bd09', component.options)
    }
    module.hot.accept("./PlanCard.vue?vue&type=template&id=4a66bd09&scoped=true", function () {
      api.rerender('4a66bd09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payment/Components/Sections/Plans/PlanCard.vue"
export default component.exports